import { Button, Fade, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MenuNotch from "./MenuNotch";
import { forwardRef } from "react";
import BotCard from "./BotCard";
import { EntityType } from "../../../_app/types";
import { useAppNavigate } from "../../../_hooks/use-app-navigate";
import { useTranslation } from "react-i18next";

interface NavBarMenuProps {
  open?: boolean;
}

const NavBarMenu = forwardRef<HTMLDivElement, NavBarMenuProps>((props, ref) => {
  const { open } = props;

  const theme = useTheme();
  const { t } = useTranslation("navBar");
  const navigate = useAppNavigate();
  const toCreationPage = (value: EntityType) => navigate.tickers(value);

  return (
    <Box
      ref={ref}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        position: "absolute",
        top: "-295px",
        paddingX: "8px",
        visibility: open ? "visible" : "hidden",
        pointerEvents: open ? "auto" : "none",
      }}
    >
      <Fade in={open}>
        <Box>
          <Box
            sx={{
              backgroundColor: theme.palette.grey[300],
              borderTopLeftRadius: "12px !important",
              borderTopRightRadius: "12px !important",
              borderBottomLeftRadius: "0px !important",
              borderBottomRightRadius: "0px !important",
              padding: "16px",
            }}
          >
            <Typography align={"center"} variant="h2" color={"textSecondary"}>
              {t("createNew")}
            </Typography>
            <Stack direction={"column"} spacing={1} sx={{ paddingTop: 3 }}>
              <Button onClick={() => toCreationPage("bot")} sx={{ display: "block", padding: 0 }}>
                <BotCard type="futures" />
              </Button>
              <Button
                onClick={() => toCreationPage("strategy")}
                sx={{ display: "block", padding: 0 }}
              >
                <BotCard type="auto-strategies" />
              </Button>
            </Stack>
          </Box>
          <MenuNotch />
        </Box>
      </Fade>
    </Box>
  );
});

export default NavBarMenu;
